import { render } from "./ui-challenge.vue?vue&type=template&id=4194f9f2&scoped=true"
import script from "./ui-challenge.vue?vue&type=script&lang=js"
export * from "./ui-challenge.vue?vue&type=script&lang=js"

import "./ui-challenge.vue?vue&type=style&index=0&id=4194f9f2&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4194f9f2"]])

export default __exports__